var auth = {
    id: null,
    continue: false,
    functionContinue: '',
    params: {
        accessPublication: false,
        publicationId: '',
        login: false,
        user_id: 0
        //loginType: '',
        //totalNotification: 0,
        //loadingText: ''
    },
    extraParams:{

    },
    init: function() {
        auth.login();
        if($("#form-register").length){
            auth.register();
        }
        auth.recover();
        if($("#affiliateRegisterForm").length){
            auth.registerAffiliate();
        }
        if($("#form-two-fa").length){
            auth.twoFaAuth();
        }
        auth.enableAccessType();
    },
    showLogin: function(accessPublication, publicationId) {
        auth.params.accessPublication = true;
        auth.params.publicationId = publicationId;
        $('#loginModal').modal('show');
    },
    showLoginContinue: function(functionName) {
        $('#loginModal').modal('show');
        auth.continue = true;
        auth.functionContinue = functionName;
    },
    redirectDashboard: function () {
        $.ajax({
            url: main.getUri('/authentication/generate-token'),
            data: $('#form-recover').serialize(),
            type: 'POST',
            dataType: "json",
            beforeSend: function (xhr) {
                xhr.overrideMimeType("text/plain; charset=x-user-defined");
            },
            success : function(data) {
                if (data.success) {
                    location.href = data.uri;
                }
                else {
                    Swal.fire({
                        type: 'error',
                        title: 'Error!',
                        text: data.message,
                    })
                }
            }
        });
        return false;
    },
    recover: function () {
        $("#form-recover").validate({
            rules: {
                email: {
                    required: true
                }
            },
            // Specify the validation error messages
            messages: {
                email: {
                    required: "Por favor ingrese su Email"
                }
            },
            /*errorPlacement: function(error, element) {
                error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
            },*/
            highlight: function(element) {
                $(element).parent('div').addClass("error-n");
            },
            unhighlight: function(element) {
                $(element).parent('div').removeClass("error-n");
            },
            submitHandler: function (form) {
                var $frm = $(form);
                $("#form-recover").find('button').css({
                    "pointer-events": "none",
                    "cursor": "not-allowed",
                    "opacity": "0.7"
                });
                $.ajax({
                    url: main.getUri('/authentication/recover'),
                    data: $('#form-recover').serialize(),
                    type: 'POST',
                    dataType: "json",
                    beforeSend: function (xhr) {
                        xhr.overrideMimeType("text/plain; charset=x-user-defined");
                    },
                    success : function(data) {
                        if (data.success) {
                            $('#form-recover').html('<p>'+data.message+'</p>');
                            $("#form-recover").find('button').removeAttr("style");
                        }
                        else {
                            Swal.fire({
                                type: 'error',
                                title: 'Error!',
                                text: data.message,
                            });
                            $("#form-recover").find('button').removeAttr("style");
                        }
                    }
                });
                return false;
            }
        });
    },
    login: function () {
        $("#form-login").validate({
            // Specify the validation rules
            rules: {
                email: {required: true},
                password: {required: true}
            },
            // Specify the validation error messages
            messages: {
                email: {required: "Escribe tu dirección de correo electrónico"},
                password: {required: "Escribe la contraseña de tu cuenta"}
            },
            errorPlacement: function(error, element) {
                error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
            },
            highlight: function(element) {
                $(element).parent('div').addClass("error-n");
            },
            unhighlight: function(element) {
                $(element).parent('div').removeClass("error-n");
            },
            submitHandler: function (form) {
                $("#form-login").find(".btn-l-primary").addClass("block-btn-load");
                var params = $('#form-login').serialize();
                params += '&accessPublication=' + auth.params.accessPublication;
                params += '&publicationId=' + auth.params.publicationId;
                params += '&activeUrl=' + main.activeUrl;

                $.ajax({
                    url: main.getUri('/authentication/send-login'),
                    data: params,
                    type: 'POST',
                    dataType: "json",
                    beforeSend: function (xhr) {
                        xhr.overrideMimeType("text/plain; charset=x-user-defined");
                    },
                    success : function(data) {
                        $("#form-login").find(".btn-l-primary").removeClass("block-btn-load");
                        if (data.success == true) {
                            auth.params.login = true;
                            if(data.twoFaEnabled){
                                $('#modal-two-fa').modal('show');
                                $('#loginModal').modal('hide');
                            } else {
                                if(auth.continue) {
                                    auth.loginFunctionContinue();
                                } else {
                                    if (auth.params.accessPublication) {
                                        location.href = data.uri;
                                    } else {
                                        location.href = data.uri;
                                    }
                                }
                            }

                        } else {
                            $('#idMessageLogin').show().addClass('block-error').html(data.message);
                        }
                    },
                    error : function(xhr, status) {

                    }
                })
                return false;
            }
        });
    },
    twoFaAuth: function () {
        $("#form-two-fa").validate({
            rules: {
                code: {
                    required: true
                }
            },
            // Specify the validation error messages
            messages: {
                code: {
                    required: "Por favor ingrese su código"
                }
            },
            /*errorPlacement: function(error, element) {
                error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
            },*/
            highlight: function(element) {
                $(element).parent('div').addClass("error-n");
            },
            unhighlight: function(element) {
                $(element).parent('div').removeClass("error-n");
            },
            submitHandler: function (form) {
                var $frm = $(form);
                $("#form-two-fa").find('button').css({
                    "pointer-events": "none",
                    "cursor": "not-allowed",
                    "opacity": "0.7"
                });
                $.ajax({
                    url: main.getUri('/authentication/send-login'),
                    data: $('#form-two-fa').serialize(),
                    type: 'POST',
                    dataType: "json",
                    beforeSend: function (xhr) {
                        xhr.overrideMimeType("text/plain; charset=x-user-defined");
                    },
                    success : function(data) {
                        if (data.success) {
                            auth.params.login = true;
                            if(auth.continue) {
                                auth.loginFunctionContinue();
                            } else {
                                if (auth.params.accessPublication) {
                                    location.href = data.uri;
                                } else {
                                    location.href = data.uri;
                                }
                            }
                        }
                        else {
                            Swal.fire({
                                type: 'error',
                                title: 'Error!',
                                text: data.message,
                            });
                            $("#form-two-fa").find('button').removeAttr("style");
                        }
                    }
                });
                return false;
            }
        });
    },
    loginFunctionContinue: function() {
        if(auth.functionContinue == 'sendCodeActivation'){
            account.sendCodeactivation();
        }
        if(auth.functionContinue == 'checkout'){
            var params = auth.extraParams;
            console.log(params);
            checkout.checkout(
                params.publicationId,
                params.itemId,
                params.type,
                params.quantity,
                params.priceId,
                params.recurring,
                params.month
            );
        }
    },
    register: function () {
        if($("#inputPhoneNumberReg").length){
            var inputPhoneNumberReg = document.querySelector("#inputPhoneNumberReg");
            var countryCode = $("#inputPhoneNumberReg").data('country');
            if(countryCode=='') {
                countryCode = 'pe';
            }
            var intPhoneNumberReg = intlTelInput(inputPhoneNumberReg, {
                initialCountry: countryCode,
                //utilsScript: main.host + "dist/js/utils.js",
                utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/18.2.1/js/utils.js",
                preferredCountries: ['pe', 'co', 'mx','ar', 'es', 'us'],
                placeholderNumberType: "MOBILE",
                separateDialCode: true
            });
        }

        $('#country').on('change', function() {
            var countryId = this.value;
            intPhoneNumberReg.setCountry(countryId);
        });

        $("#form-register").validate({
            // Specify the validation rules
            rules: {
                name:   { required: true },
                lastName: { required: true },
                email: { required: true },
                password: { required: true },
                country: { required: true },
                phone: { required: true },
                interes: { required: true },
                checkTermCondition : { required: true }
            },
            messages:{
                name: { required: "Por favor ingrese su Nombre" },
                lastName: { required: "Por favor ingrese su Apellido"  },
                email: { required: "Por favor ingrese su Email" },
                country: {  required: "Por favor Reingrese su Pais" },
                password: { required: "Por favor ingrese su Password" },
                phone: { required: "Por favor ingrese su Télefono" },
                interes: { required: "Requerido" },
                checkTermCondition: { required: "Requerido" }
            },
            errorPlacement: function(error, element) {
                error.insertBefore($(element).parents('.form-field__control').find('.error-cnt').html(error));
            },
            highlight: function(element) {
                $(element).parent('div').addClass("error-n");
            },
            unhighlight: function(element) {
                $(element).parent('div').removeClass("error-n");
            },
            submitHandler: function (form) {
                $("#form-register").find(".btn-l-primary").addClass("block-btn-load");
                var params = $('#form-register').serialize();
                params += '&accessPublication=' + auth.params.accessPublication;
                params += '&publicationId=' + auth.params.publicationId;
                params += '&activeUrl=' + main.activeUrl;
                params += '&phone=' + $('#form-register .selected-dial-code').text() + '-' + $('#inputPhoneNumberReg').val() ;
                $.ajax({
                    url: main.getUri('/authentication/send-register'),
                    data: params,
                    type: 'POST',
                    dataType: "json",
                    beforeSend: function (xhr) {
                        xhr.overrideMimeType("text/plain; charset=x-user-defined");
                    },
                    success : function(data) {
                        $("#form-register").find(".btn-l-primary").removeClass("block-btn-load");
                        if(data.success == true) {
                            if(analityc.status) {
                                analityc.trackCompleteRegistration();
                            }
                            if (data.type == 'validation') {
                                $('#registrameModal').modal('hide');
                                $('#registrameModal').trigger("reset");
                                $('#verificationModal').modal({
                                    backdrop: 'static',
                                    show: true
                                });
                                auth.registerTwoSteps(); //activate
                                auth.params.user_id = data.user_id;
                            } else {
                                auth.params.login = true;
                                if(auth.continue) {
                                    auth.loginFunctionContinue();
                                } else {
                                    location.href = data.uri;
                                }
                            }
                        } else {
                            $('#idMessageRegister').html(data.message);
                        }
                    }
                });
                return false;
            }
        });
    },
    registerTwoSteps: function() {
        $("#form-validation-register").validate({
            rules: {
                validation: {
                    required: true
                }
            },
            messages: {
                validation: {required: "Por favor escriba el código enviado a su correo."},
            },
            submitHandler: function (form) {
                token = document.getElementById('validation').value;

                $.ajax({
                    url: main.getUri('/authentication/send-validation-account'),
                    data: {'user': auth.params.user_id, 'token': token},
                    type: 'POST',
                    dataType: "json",
                    beforeSend: function (xhr) {
                        xhr.overrideMimeType("text/plain; charset=x-user-defined");
                    },
                    success : function(data) {
                        $("#verificationModal").find(".btn-l-primary").removeClass("block-btn-load");
                        if (data.success == true) {
                            location.href = data.uri;
                        } else {
                            $('#idMessageLogin').show().addClass('block-error').html(data.message);
                        }
                    },
                    error : function(xhr, status) {

                    }
                })
            }
        })
    },
    registerTeacher: function () {
        if($("#inputPhoneNumberRegTeacher").length){
            var inputPhoneNumberReg = document.querySelector("#inputPhoneNumberRegTeacher");

            var intPhoneNumberReg = intlTelInput(inputPhoneNumberReg, {
                initialCountry: "",
                //utilsScript: main.host + "dist/js/utils.js",
                utilsScript: "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
                preferredCountries: ['pe', 'co', 'mx','ar', 'es', 'us'],
                placeholderNumberType: "MOBILE",
                separateDialCode: true
            });
        }
        $('#countryTeacher').on('change', function() {
            var countryId = this.value;
            intPhoneNumberReg.setCountry(countryId);
        });
        $("#form-register-teacher").validate({
            // Specify the validation rules
            rules: {
                name:   { required: true },
                lastName: { required: true },
                email: { required: true },
                password: { required: true },
                country: { required: true },
                phone: { required: true  }
            },
            messages:{
                name: { required: "Por favor ingrese su Nombre" },
                lastName: { required: "Por favor ingrese su Apellido"  },
                email: { required: "Por favor ingrese su Email" },
                country: {  required: "Por favor Reingrese su Pais" },
                password: { required: "Por favor ingrese su Password" },
                phone: { required: "Por favor ingrese su Télefono" }
            },
            errorPlacement: function(error, element) {
                error.insertBefore($(element).parents('.cnt-content-list-e').find('.error-cnt').html(error));
            },
            submitHandler: function (form) {
                $("#form-register-teacher").find(".btn-l-primary").addClass("block-btn-load");
                var params = $('#form-register-teacher').serialize();
                params += '&accessPublication=' + auth.params.accessPublication;
                params += '&publicationId=' + auth.params.publicationId;
                params += '&activeUrl=' + main.activeUrl;
                params += '&phone=' + $('#form-register-teacher .selected-dial-code').text() + '-' + $('#inputPhoneNumberReg').val() ;
                $.ajax({
                    url: main.getUri('/authentication/register'),
                    data: params,
                    type: 'POST',
                    dataType: "json",
                    beforeSend: function (xhr) {
                        xhr.overrideMimeType("text/plain; charset=x-user-defined");
                    },
                    success : function(data) {
                        $("#form-register-teacher").find(".btn-l-primary").removeClass("block-btn-load");
                        if(data.success == true) {
                            Swal.fire({
                                type: 'success',
                                title: 'Ok',
                                text: 'Gracias por registrate, pronto nos pondremos en contacto con usted',
                            })
                            $("#registerTeacherModal").modal('hide');
                        } else {
                            $('#idMessageRegister').html(data.message);
                        }
                    }
                });
                return false;
            }
        });
    },
    registerAffiliate: function() {

      if ($("#inputPhoneNumberReg").length){
        var inputPhoneNumberReg = document.querySelector("#inputPhoneNumberReg");
        var countryCode = $("#inputPhoneNumberReg").data('country');
        if (countryCode=='') {
            countryCode = 'pe';
        }
        var intPhoneNumberReg = intlTelInput(inputPhoneNumberReg, {
            initialCountry: countryCode,
            //utilsScript: main.host + "dist/js/utils.js",
            utilsScript: "https://intl-tel-input.com/node_modules/intl-tel-input/build/js/utils.js?1549804213570",
            preferredCountries: ['pe', 'co', 'mx','ar', 'es', 'us'],
            placeholderNumberType: "MOBILE",
            separateDialCode: true
        });
      }
      $('#country').on('change', function() {
        var countryId = this.value;
        intPhoneNumberReg.setCountry(countryId);
      });
    
      $("#affiliateRegisterForm").validate({
        rules: {
          name: "required",
          lastName: "required",
          nameBusiness: "required",
          country: "required",
          accessType: "required",
          "term-condition": "required",
          "politicas-priv": "required",
          email: {
            required: true,
            email: true,
          },
          password: {
            required: true,
          },
          phoneLocal: {
            required: true,
            number: true
          }
        }, 
        // Specify the validation error messages
        messages: {
          name: "Ingrese su nombre",
          lastName: "Ingrese su apellido",
          nameBusiness: "Ingrese su sitio web",
          password: {
            required: "Ingrese su Contraseña",
          },
          email: "Ingrese su correo electrónico correcto",
          phoneLocal: {
            required: "Ingrese su número",
            number: "Ingrese solo números"
          },
          country: "Elige un país",
          accessType: "Este campo es obligatorio",
          "term-condition": "Acepta los términos y condiciones",
          "politicas-priv": "Acepta las Políticas de Privacidad"
        },
        submitHandler: function (form) {
          $("#idDivError").html("");
          $("#idBtnRegisterPartner").text("Procesando..");
          $("#idBtnRegisterPartner").attr("disabled", true);
          var paramsLocal = $("#affiliateRegisterForm").serialize();
          paramsLocal += "&ip=" + auth.ip;
          paramsLocal +=
            "&phone=" +
            $("#affiliateRegisterForm .selected-dial-code").text() +
            "-" +
            $("#inputPhoneNumberReg").val();
          $.ajax({
            url: "/es/affiliate/send-register", 
            data: paramsLocal,
            type: "POST",
            dataType: "json",
            success: function (response) {
              //Reseteando el boton cargando...
              $("#security").val(response.token);
              if (response.success) {
                console.log('response.data', response.data);                
                location.href = response.data.redirectUrl;
              } else {
                $("#idDivError").html(
                  '<div class="idDivError"  style="margin-bottom: 10px;">' +
                    response.message +
                    "</div>"
                );
                $("#idBtnRegisterPartner").text("Registrar mi cuenta");
                $("#idBtnRegisterPartner").attr("disabled", false);
              }
            },
            error: function (xhr, status, errorThrown) {
              $("#ridBtnRegisterPartner").text("Registrar mi cuenta");
              $("#idBtnRegisterPartner").attr("disabled", false);
            },
          });
          return false;
        },
      });
    },
    enableAccessType: function() {    
      $('#idBtnEnableAccessType').click(function (e) {			
        e.preventDefault();
        $.ajax({
          url:  '/es/affiliate/enable-access-type',
          data: $('#idFormEnableAccessType').serialize(),
          type: 'POST',
          dataType: "json",
          success : function(response) {
            if (response.success) {
              location.href = response.data.redirectUrl;
            } else {
              Swal.fire({type: 'error',title: 'Oops...',text: 'Se produjo un error, intentalo en unos minutos.'})  
            }					
          },
          error : function(xhr, status) {
            Swal.fire({type: 'error',title: 'Oops...',text: 'Se produjo un error, intentalo en unos minutos.'})
          }
        });
      });
    },
}
